/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize Access List View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './AccessListView';

export const mapStateToPropsAccessList = mapStateToProps;
export const mapDispatchToPropsAccessList = mapDispatchToProps;

export default connect(
  mapStateToPropsAccessList,
  mapDispatchToPropsAccessList
)(View);
